<aside [class]="classes().container()">
  <div [class]="classes().header()">
    <img [class]="classes().logo()" [src]="whitelabel.logo()" [alt]="'globals.logo' | transloco" />
  </div>

  @if (ctaTemplate(); as ctaTemplateRef) {
    <ng-container *ngTemplateOutlet="ctaTemplateRef" />
  }

  <nav [class]="classes().nav()">
    <ul [class]="classes().list()">
      @for (content of renderedMenuContents(); track $index) {
        <li class="flex flex-col">
          @switch (content.type) {
            @case (MenuItemType.Section) {
              <ng-container
                *ngTemplateOutlet="sectionTpl; context: { $implicit: asSection(content) }"
              />
            }
            @case (MenuItemType.Item) {
              <ng-container
                *ngTemplateOutlet="linkItemTpl; context: { $implicit: asItem(content) }"
              />
            }
            @case (MenuItemType.Spacer) {
              <div class="bg-muted my-2 h-px w-full"></div>
            }
          }
        </li>
      }
    </ul>
  </nav>

  <footer [class]="classes().userContainer()">
    <edu-user-menu
      [isLoading]="userResource().isLoading()"
      [firstname]="userResource().value()?.firstname"
      [lastname]="userResource().value()?.lastname"
      [email]="userResource().value()?.email"
      [avatarUrl]="userResource().value()?.avatarUrls?.dashboard"
      (logout)="onLogout()"
    />
  </footer>
</aside>

<ng-template #linkItemTpl let-item>
  @if (getLinkClassesForItem(item); as itemClasses) {
    <div class="w-full">
      <a [routerLink]="item.route" [class]="itemClasses.link()" routerLinkActive="active">
        <edu-icon [icon]="item.icon" [class]="itemClasses.icon()" />
        <span [class]="itemClasses.text()">{{ item.label | transloco }}</span>
      </a>
    </div>
  }
</ng-template>

<ng-template #sectionTpl let-section>
  @if (getSectionClasses(section); as sectionClasses) {
    @if (section.labelKey) {
      <button
        type="button"
        [class]="sectionClasses.header()"
        [attr.aria-expanded]="section.isCollapsible ? isSectionExpanded(section) : null"
        [disabled]="!section.isCollapsible"
        (click)="toggleSection(section)"
      >
        <span [class]="sectionClasses.label()">{{ section.labelKey | transloco }}</span>
        @if (section.isCollapsible) {
          <edu-icon [icon]="Icon.CHEVRON_DOWN" [class]="sectionClasses.toggle()" />
        }
      </button>
    }
    <cdk-accordion>
      <cdk-accordion-item #accordionItem="cdkAccordionItem" [expanded]="isSectionExpanded(section)">
        <div
          class="grid transition-[grid-template-rows] duration-200 ease-out motion-reduce:transition-none"
          [ngClass]="{
            'grid-rows-[1fr]': accordionItem.expanded,
            'grid-rows-[0fr]': !accordionItem.expanded,
          }"
        >
          <ul class="flex flex-col gap-0.5 overflow-hidden">
            @for (sectionItem of section.items; track sectionItem.route) {
              <ng-container *ngTemplateOutlet="linkItemTpl; context: { $implicit: sectionItem }" />
            }
          </ul>
        </div>
      </cdk-accordion-item>
    </cdk-accordion>
  }
</ng-template>
